export enum ENearEnvironment {
	MAIN_NET = "mainnet",
	TEST_NET = "testnet",
	BETA_NET = "betanet",
	TEST = "test",
}
